import { render } from "./add-fom.vue?vue&type=template&id=2bc24f56"
import script from "./add-fom.vue?vue&type=script&lang=js"
export * from "./add-fom.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__